import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Terms: React.FC = () => {
  return (
    <div className="App">
      <Header />
      <main className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="font-serif text-5xl font-light leading-tight tracking-tight text-gray-900 mb-8">
            Terms of Service
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-8">
              Last updated: January 27, 2025
            </p>

            <section className="mb-8">
              <h2 className="font-serif text-3xl font-light text-gray-900 mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-700 mb-4">
                By accessing and using Relatable's services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-3xl font-light text-gray-900 mb-4">2. Use License</h2>
              <p className="text-gray-700 mb-4">
                Permission is granted to temporarily download one copy of the materials (information or software) on Relatable's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
              </p>
              <ul className="list-disc pl-6 mb-4 text-gray-700">
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose or for any public display</li>
                <li>Attempt to reverse engineer any software contained on Relatable's website</li>
                <li>Remove any copyright or other proprietary notations from the materials</li>
                <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-3xl font-light text-gray-900 mb-4">3. Service Description</h2>
              <p className="text-gray-700 mb-4">
                Relatable provides personal CRM services including contact management, relationship tracking, communication history, and team collaboration features. Our services are designed to help users organize and maintain their professional and personal relationships.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-3xl font-light text-gray-900 mb-4">4. User Accounts</h2>
              <p className="text-gray-700 mb-4">
                You are responsible for maintaining the confidentiality of your account and password. You agree to accept responsibility for all activities that occur under your account or password.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-3xl font-light text-gray-900 mb-4">5. Payment Terms</h2>
              <p className="text-gray-700 mb-4">
                Subscription fees are billed in advance on a monthly basis. All fees are non-refundable except as required by law. We reserve the right to change our pricing with 30 days notice.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-3xl font-light text-gray-900 mb-4">6. Data and Privacy</h2>
              <p className="text-gray-700 mb-4">
                Your data belongs to you. We will not sell, share, or use your information for purposes other than providing our services. Please review our Privacy Policy for detailed information about how we handle your data.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-3xl font-light text-gray-900 mb-4">7. Acceptable Use</h2>
              <p className="text-gray-700 mb-4">
                You agree not to use our services to:
              </p>
              <ul className="list-disc pl-6 mb-4 text-gray-700">
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe upon the rights of others</li>
                <li>Transmit harmful, offensive, or inappropriate content</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Interfere with the proper functioning of our services</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-3xl font-light text-gray-900 mb-4">8. Service Availability</h2>
              <p className="text-gray-700 mb-4">
                We strive to maintain high availability of our services, but we do not guarantee uninterrupted access. We may perform maintenance or updates that temporarily affect service availability.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-3xl font-light text-gray-900 mb-4">9. Intellectual Property</h2>
              <p className="text-gray-700 mb-4">
                The content, features, and functionality of our services are owned by RogerTen, LLC and are protected by copyright, trademark, and other intellectual property laws.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-3xl font-light text-gray-900 mb-4">10. Limitation of Liability</h2>
              <p className="text-gray-700 mb-4">
                In no event shall Relatable or its suppliers be liable for any damages arising out of the use or inability to use our services, even if we have been notified orally or in writing of the possibility of such damage.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-3xl font-light text-gray-900 mb-4">11. Termination</h2>
              <p className="text-gray-700 mb-4">
                We may terminate or suspend your account and access to our services at any time, with or without cause, with or without notice. Upon termination, your right to use our services will cease immediately.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-3xl font-light text-gray-900 mb-4">12. Changes to Terms</h2>
              <p className="text-gray-700 mb-4">
                We reserve the right to modify these terms at any time. We will notify users of any material changes by posting the new terms on our website and updating the "Last updated" date.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-3xl font-light text-gray-900 mb-4">13. Governing Law</h2>
              <p className="text-gray-700 mb-4">
                These terms shall be governed by and construed in accordance with the laws of the state of Maryland, without regard to its conflict of law provisions.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-3xl font-light text-gray-900 mb-4">14. Contact Information</h2>
              <p className="text-gray-700 mb-4">
                If you have any questions about these Terms of Service, please contact us at:
              </p>
              <p className="text-gray-700">
                Email: hello@relatable.one<br />
                Address: RogerTen, LLC<br />
                Website: https://www.relatable.one
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
